import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getVehicleColorType } from '../thunks/vehicleThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearVehicleKey } from '../thunkKeys/commonThunksKeys';

const SLICE_NAME = 'colorVehicleType';

export const colorVehicleTypeSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearColorVehicleType(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getVehicleColorType });
        builder.addCase(
            clearVehicleKey,
            () => commonInitialState,
        );
    },
});

export const { clearColorVehicleType } = colorVehicleTypeSlice.actions;

export const colorVehicleType = colorVehicleTypeSlice.reducer;
